
import NewsArticlesWidget from "@widgets/message-center/NewsArticlesWidget";
import NewsArticlesWidgetV2 from "@widgets/message-center/NewsArticlesWidgetV2";
import { BaseWidgetProps } from "shared-ui";
import { useFeatureFlag } from "shared-ui/src/utils/FeatureFlagHelper";

export default function NewsAndUpdatesWidget({
  pageLayoutWidget,
}: Readonly<BaseWidgetProps>) {
  const { data: isUnifiedDashboard } = useFeatureFlag(
    "synergists.unity-dashboard",
    false,
  );

  if (isUnifiedDashboard) {
    return <NewsArticlesWidgetV2 pageLayoutWidget={pageLayoutWidget} />;
  }

  return <NewsArticlesWidget pageLayoutWidget={pageLayoutWidget} />;
}
